import { message } from 'antd';
import ErrorMessage from 'apis/ErrorMessage';
import { STORY, ifyouApi, kevinAuthAPI, kevinCommonAPI } from 'apis/config';
import { ICreateStory, IProject } from 'utils/types/storyTypes';
export const storyApi = {
  //  new story api
  list: () =>
    kevinAuthAPI
      .get(`/story`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  supportLang: () =>
    kevinCommonAPI
      .get(`/common/lang`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  bubbleList: (lang: string) =>
    kevinAuthAPI
      .get(`/common/etc/bubble?lang=${lang}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  projectTypeList: () =>
    kevinAuthAPI
      .get(`/common/project_type`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  primeCurrencyList: (lang: string) =>
    kevinAuthAPI
      .get(`/common/localize/prime_currency?lang=${lang}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  createSoty: (data: ICreateStory) =>
    kevinAuthAPI
      .post(`/story`, data)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // * 프로젝트 상세정보 수정
  updateDetailStory: (id: number | undefined, values: IProject) => {
    return kevinAuthAPI
      .put(`${STORY}/${id}`, {
        update: values,
      })
      .then((res) => {
        if (res.data) {
          message.success('Update success', 1);
        }
      })
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  storyDetail: (id: string | undefined) =>
    kevinAuthAPI
      .get(`/story/${id}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete: (id: number) =>
    kevinAuthAPI
      .delete(`/story/${id}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  // * 프로젝트 언어별 ICON 업로드
  uploadProjectIcon: (project_id: number, lang: string, file: any) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .patch(`/story/icon-upload/${project_id}/${lang}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  episodeDetail: (id: string | undefined) =>
    kevinAuthAPI
      .get(`/story/${id}/episode`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  // old story api
  read: (lang: string, userId: string, masterAuth: number) =>
    ifyouApi
      .post(``, { lang: lang, user_id: userId, master_auth: masterAuth })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  register: ({ title, project_type }) =>
    ifyouApi
      .post(`${STORY}/register-story`, {
        title: title,
        project_type: project_type,
      })
      .then((res) => res.data),
  selectProjectInfo: (projectId, lang) =>
    ifyouApi
      .post(`${STORY}/${projectId}`, {
        lang: lang,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  projectDetail: (projectId, lang) =>
    ifyouApi
      .post(`${STORY}/${projectId}/story-detail`, {
        lang: lang,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
